import { Fragment } from 'react';

import { useTariffFeatures } from 'components/direct-sales/quote/hooks/useTariffFeatures';
import { NsList } from 'components/common/ns-list/NsList';

type AboutTariffProps = {
  product: object;
};

export const AboutTariff = ({ product }: AboutTariffProps) => {
  const aboutUsFeatures = useTariffFeatures(product);

  if (!aboutUsFeatures?.length) return null;

  return (
    <>
      <h4>About this tariff</h4>
      <NsList>
        {aboutUsFeatures.map((feature, index) => (
          <Fragment key={index}>{feature.description}</Fragment>
        ))}
      </NsList>
    </>
  );
};
